import {
  getPathnameFromUrl,
  removeRouterBasename,
  removeStartingSlash,
} from '../../../../../utils/locationUtils';

export const getOpenMenuIdFromUrl = (link, depth, store) => {
  const pathname = getPathnameFromUrl(link);
  const linkWithoutStartingSlash = removeStartingSlash(
    removeRouterBasename(pathname, store.storePath),
  );
  const openTrees = linkWithoutStartingSlash.split('/');
  return (openTrees && openTrees[depth + 1]) || 'closeAll';
};
